<!--
 * @Author: your name
 * @Date: 2020-09-08 09:37:08
 * @LastEditTime: 2023-01-18 22:19:28
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\accountConfirm\list.vue
-->
<template>
    <div class="commonTableStyles accountConfirm-list">
        <van-nav-bar
            title="账务列表"
            left-text="首页"
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <van-search v-model="searchValue" placeholder="请输入搜索信息" @change="search"></van-search>
        <van-pull-refresh
            v-model="isLoading"
            @refresh="onRefresh"
        >
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
            >
                <ul class="list">
                    <li v-for="(item,index) in orderList" :key="item.contract_number + index">
                        <div class="engineeringInfo" @click="toDetail(item)">
                            <h4 class="engineeringInfo_header">
                                <span class="headerName">收款编号：{{ item.proceeds_number }}</span>
                                <strong class="contractStatus" :class="getClass(item.approval_status_name)">
                                    {{ item.approval_status_name }}
                                </strong>
                            </h4>
                            <div class="engineeringInfo_content">
                                <p>
                                    <span class="info">合同编号：{{ item.contract_number }}</span>
                                </p>
                                <p>
                                    <span class="info">客户名称：{{ item.client_name }}</span>
                                </p>

                                <p>
                                    <span class="info">工程名称：{{ item.engineering_name }}</span>
                                </p>
                                <p>
                                    <span class="info">结算周期开始时间：{{ item.settlement_start_time }}</span>
                                </p>
                                <p>
                                    <span class="info">结算周期结束时间：{{ item.settlement_end_time }}</span>
                                </p>
                                <p>
                                    <van-row>
                                        <van-col span="12">
                                            <span class="info">期初应收：{{ item.Initial_receivables }}</span>
                                        </van-col>
                                        <van-col span="12">
                                            <span class="info">期末应收余额：{{ item.ending_balance_receivable }}</span>
                                        </van-col>
                                    </van-row>
                                </p>
                                <p>
                                    <van-row>
                                        <van-col span="12">
                                            <span class="info">本期应收：{{ item.loans_receivable }}</span>
                                        </van-col>
                                        <van-col span="12">
                                            <span class="info">本期实收：{{ item.official_receipt }}</span>
                                        </van-col>
                                    </van-row>
                                </p>
                                <p>
                                    <span class="info">收款日期：{{ item.receipt_date }}</span>
                                </p>
                            </div>
                        </div>
                        <div class="form">
                            <button @click.stop="openHistoryList(item.contract_number)">
                                历史记录
                            </button>
                        </div>
                    </li>
                </ul>
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
export default {
    name: 'account-confirm-list',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.keywords = '';
            this.$store.commit('noKeepAlive', 'account-confirm-list');
        }
        next();
    },
    components: {},
    props: {},
    data() {
        return {
            orderList: [],
            loading: false,
            finished: false,
            page: {
                pageindex: 0,
                pagesize: 3,
            },
            // 下拉刷新
            isLoading: false,
            // 查询条件
            searchValue: '',
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {},
    methods: {
        // 返回
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 跳转到确认页面
        toDetail(data) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'accountConfirmInfo', params: { data: data } });
        },
        getClass(name) {
            let str = 'status ';
            if (name === '已提交') {
                str += 'status1';
            } else if (name === '未提交') {
                str += 'status0';
            } else if (name === '已确认') {
                str += 'status2';
            }
            return str;
        },
        // 下拉刷新
        onRefresh() {
            this.page.pageindex = 0;
            this.finished = false;
            this.loading = true;
            this.onLoad();
        },
        // 条件查询
        search() {
            this.page.pageindex = 0;
            this.orderList = [];
            this.finished = false;
            this.loading = true;
            this.onLoad();
        },
        onLoad() {
            if (this.isLoading) {
                this.orderList = [];
                this.isLoading = false;
            }
            this.page.pageindex += 1;
            this.getListPage();
        },
        async getListPage() {
            const res = await this.getListApi();
            if (res) {
                this.showOverlay = false;
                this.loading = false;
                this.isLoading = false;
                if (res.total) {
                    this.total = true;
                    this.orderList = this.orderList.concat(res.rows);
                    if (this.orderList.length >= res.total) {
                        this.finished = true;
                    }
                } else {
                    this.total = false;
                    this.finished = true;
                }
            }
        },

        // 打开收款记录历史记录
        openHistoryList(contract_number) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'accountConfirmHistoryList',
                params: {
                    contract_number,
                },
            });
        },

        getListApi() {
            const queryStr = '?pageindex=' + this.page.pageindex + '&pagesize=' + this.page.pagesize + '&keyword=' + this.searchValue;
            return this.$axios.$get('/interfaceApi/sale/accounts/get_proceeds_confirm_list' + queryStr, { defEx: true });
        },
    },
};
</script>
<style lang="stylus">
.accountConfirm-list
    height 100%
    background #F0F0F0
    .van-pull-refresh
        height calc(100% - 90rpx)
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        .van-pull-refresh__track
            height 100%
    .van-nav-bar
        .van-nav-bar__title
            div
                display inline-block
                padding 0 15rpx
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 18rpx
                    color #fff
    .van-overlay
        .van-loading
            position absolute
            z-index 100
            top 50%
            left 50%
    .search-con
        .van-search
            padding 15rpx 12rpx 15rpx 12rpx
    .van-pull-refresh__head
        background #F0F0F0
    .list
        li
            .status
                &.status0
                    color #0101B5
                &.status1
                    color #00A84B
                &.status2
                    color #FF6600

</style>